export let DateFormat;
(function (DateFormat) {
  DateFormat["DEFAULT_LOCALE_BASED"] = "default";
  DateFormat["DWWWW_MMMM_D_YYYY"] = "DWWWW_MMMM_D_YYYY";
  DateFormat["DWWW_DD_MMM_YYYY"] = "DWWW_DD_MMM_YYYY";
  DateFormat["DWWW_MM_DD_YYYY"] = "DWWW_MM_DD_YYYY";
  DateFormat["D_MMMM"] = "D_MMMM";
  DateFormat["D_MMM_YYYY"] = "D_MMM_YYYY";
  DateFormat["MMMM_D"] = "MMMM_D";
  DateFormat["MMMM_D_YYYY"] = "MMMM_D_YYYY";
  DateFormat["MMM_D_YYYY"] = "MMM_D_YYYY";
  DateFormat["YYYY_MM_DD_DOT"] = "YYYY_MM_DD_DOT";
  DateFormat["YYYY_MM_DD_HYPHEN"] = "YYYY_MM_DD_HYPHEN";
})(DateFormat || (DateFormat = {}));
//# sourceMappingURL=Date.js.map